import * as React from "react"

import "./checkbox.scss"

interface Checkbox extends React.HTMLProps<HTMLDivElement> {
	label?: string
	name?: string
	onChange: (even: React.ChangeEvent<HTMLInputElement>) => void
	checked: boolean
	value?: string | number
}

const Checkbox: React.FC<Checkbox> = ({
	children,
	label,
	id,
	name,
	className = "",
	checked,
	onChange,
	...rest
}) => {
	return (
		<div className={`checkbox ${className}`} {...rest}>
			<input
				id={id}
				name={name}
				type="checkbox"
				checked={checked}
				className="checkbox__input"
				onChange={onChange}
			/>
			<label htmlFor={id} className="checkbox__label">
				{label || children}
			</label>
		</div>
	)
}

export default Checkbox
